<template>
  <div class="line-divider">
    <div class="line-divider__block" />
    <p
      v-if="text"
      class="line-divider__text"
    >
      {{ text }}
    </p>
    <div class="line-divider__block" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'LineDivider',
  props: {
    text: {
      type: String,
      default: '',
    },
  },
});

</script>

<style lang="scss" src="./styles.scss" />
